import { ChainId } from '@pancakeswap/sdk'
import { Address } from 'viem'

import { ProfileSupportedChainId, SupportedChainId } from './supportedChains'

export type ContractAddresses<T extends ChainId = SupportedChainId> = {
  [chainId in T]: Address
}

export const ICAKE = {
  [ChainId.PULSECHAIN]: '0x9C46110Eb094866922045729AEFcdff91f2CFFF5',
  // [ChainId.POLYGON_ZKEVM]: '0x6ebfF05D15808Ff3065b8e0F71ff541998ebe2e2',
} as const satisfies ContractAddresses<SupportedChainId>

// Used to send cross chain message
// Name derived from smart contract
export const INFO_SENDER = {
  [ChainId.PULSECHAIN]: '0x63772320a2FA3B9002A863126806b9EeF23e9C81',
} as const satisfies ContractAddresses<ProfileSupportedChainId>
